import ListIFrames from "../Components/Iframes/ListIFrames";
const ListOfIframes = () => {
  return (
  <ListIFrames />
  );
};

export default ListOfIframes;
